// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";

function getVm(partner_earnings, currency) {
  var total_earnings = List.fold_left((function (b, a) {
          return Currency.fromCurrency(a.amount) + b;
        }), 0.0, partner_earnings.earnings);
  var l = List.map((function (e) {
          return {
                  amount: Currency.toCurrencyString(e.amount, currency),
                  _type: e._type,
                  default_title: e.default_title
                };
        }), partner_earnings.earnings);
  return {
          earnings: List.append(l, {
                hd: {
                  amount: Currency.toCurrencyString(Currency.toCurrency(total_earnings), currency),
                  _type: "TOTAL_EARNINGS",
                  default_title: "Total Earnings"
                },
                tl: /* [] */0
              }),
          settlements: List.map((function (param) {
                  return {
                          mode: param.default_title,
                          time: Date$Catalyst.toString("DD/MM/YY hh:mm A", param.settlement_ts),
                          amount: Currency.toCurrencyString(param.amount, currency)
                        };
                }), partner_earnings.settlements),
          inclusions: List.map((function (param) {
                  return {
                          title: param.default_title,
                          amount: Currency.toCurrencyString(param.amount, currency)
                        };
                }), partner_earnings.inclusions)
        };
}

export {
  getVm ,
  
}
/* Date-Catalyst Not a pure module */
